var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResponsesEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6262 1.60709C11.7726 1.75354 11.7726 1.99098 11.6262 2.13742L10.844 2.91958L9.34403 1.41958L10.1262 0.637423C10.2726 0.490976 10.5101 0.490976 10.6565 0.637423L11.6262 1.60709Z",
    fill: "#0923E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3137 3.44991L8.8137 1.94991L3.70396 7.05966C3.66279 7.10083 3.63178 7.15101 3.61337 7.20624L3.00995 9.0165C2.96109 9.16308 3.10054 9.30253 3.24712 9.25367L5.05738 8.65025C5.11261 8.63184 5.16279 8.60083 5.20396 8.55966L10.3137 3.44991Z",
    fill: "#0923E6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.75 10.2776C0.75 10.8989 1.25368 11.4026 1.875 11.4026H10.125C10.7463 11.4026 11.25 10.8989 11.25 10.2776V5.77759C11.25 5.57048 11.0821 5.40259 10.875 5.40259C10.6679 5.40259 10.5 5.57048 10.5 5.77759V10.2776C10.5 10.4847 10.3321 10.6526 10.125 10.6526H1.875C1.66789 10.6526 1.5 10.4847 1.5 10.2776V2.02759C1.5 1.82048 1.66789 1.65259 1.875 1.65259H6.75C6.95711 1.65259 7.125 1.48469 7.125 1.27759C7.125 1.07048 6.95711 0.902588 6.75 0.902588H1.875C1.25368 0.902588 0.75 1.40627 0.75 2.02759V10.2776Z",
    fill: "#0923E6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResponsesEditIcon);
export default __webpack_public_path__ + "static/media/responses-edit-icon.a0b9138b50dd9be836c24184147e3b58.svg";
export { ForwardRef as ReactComponent };